import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getWorksMaterialConsumptionRateNorms: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].GET_WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,
	},
	getBaseWorksMaterialConsumptionRateNorms: {
		useCache: true,
		cacheStorage: STORE_MAP.BASE,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].GET_WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,
	},
	getExtendedWorksMaterialConsumptionRateNorms: {
		useCache: true,
		cacheStorage: STORE_MAP.EXTENDED,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].GET_WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,
	},
	createWorksMaterialConsumptionRateNorm: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].CREATE_WORKS_MATERIAL_CONSUMPTION_RATE_NORM,
	},
	getWorksMaterialConsumptionRateNorm: {
		useCache: true,
		isSingleCachedEntity: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].GET_WORKS_MATERIAL_CONSUMPTION_RATE_NORM,
	},
	patchWorksMaterialConsumptionRateNorm: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].PATCH_WORKS_MATERIAL_CONSUMPTION_RATE_NORM,
	},
	putWorksMaterialConsumptionRateNorm: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].PUT_WORKS_MATERIAL_CONSUMPTION_RATE_NORM,
	},
	deleteWorksMaterialConsumptionRateNorm: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].DELETE_WORKS_MATERIAL_CONSUMPTION_RATE_NORM,
	},
}